import Header from "./Component/Frame1/Header";
import WhatWeDo from "./Component/Frame2/WhatWeDo";
import About from "./Component/Frame3/About";
import Blog from "./Component/Frame4/Blog";
import SignUp from "./Component/Frame5/SignUp";
import Footer from "./Component/Frame6/Footer";
function App() {
  return (
    <>
    <Header/>
    <WhatWeDo/>
    <About/>
    <Blog/>
    <SignUp/>
    <Footer/>
    </>
  );
}

export default App;
